module.exports = __webpack_public_path__ + "img/A-801-820.38079d82.svg";